export default __webpack_public_path__ + "static/banner-a762240e5e056abbd1dd9fb917b2e511.jpg";